import { useEffect, useState } from 'react';

import { AudioInputDevice, listAudioInputDevices } from './audioInputDevices';
import { ensureMicrophoneAccess } from './ensureMicrophoneAccess';

export const useAudioInputDevices = (): AudioInputDevice[] => {
   const [devices, setDevices] = useState<AudioInputDevice[]>([]);

   useEffect(() => {
      let active = true;

      const refresh = async (): Promise<void> => {
         const nextDevices = await listAudioInputDevices();
         if (active) {
            setDevices(nextDevices);
         }
      };

      ensureMicrophoneAccess().then(refresh);
      navigator.mediaDevices.addEventListener('devicechange', refresh);

      return () => {
         active = false;
         navigator.mediaDevices.removeEventListener('devicechange', refresh);
      };
   }, []);

   return devices;
};
